// AboutUs.js - With Working EmailJS Integration + Auto-Flying Cards Section
import Momentsia_logo from "../images/Momentsia _logo.png";
import React, { useEffect, useState, useRef } from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer"; // <-- ADD THIS IMPORT
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import StarIcon from "@mui/icons-material/Star";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TimelineIcon from "@mui/icons-material/Timeline";
import GroupsIcon from "@mui/icons-material/Groups";
import CelebrationIcon from "@mui/icons-material/Celebration";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import BuildIcon from "@mui/icons-material/Build";
import emailjs from '@emailjs/browser';
import director1 from "../images/director1.png";
import director2 from "../images/director2.jpg";
import {
  Box,
  Container,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { PlayArrow, Pause, RestartAlt } from "@mui/icons-material";
import image_0901 from "../images/image_0901.jpg";

// ══════════════════════════════════════════════════════════
//  MOMENTSIA — About Us Page (With Working Email Form)
// ══════════════════════════════════════════════════════════

const T1 = "#0ecfb0";
const T2 = "#0aa896";
const T3 = "#077a6e";
const NAVY = "#0d1b2a";
const NAVY2 = "#112233";
const DARK = "#1a1a1a";
const TEAL_GRAD = `linear-gradient(135deg, ${T1}, ${T3})`;

// EmailJS Configuration
const EMAILJS_SERVICE_ID = "service_zieecow";      
const EMAILJS_TEMPLATE_ID = "template_l1xmaal";     
const EMAILJS_PUBLIC_KEY = "q2O06yijgnOJTch1m"; 

const eventTypes = [
  "Corporate Event",
  "Wedding",
  "Birthday Party",
  "Conference",
  "Product Launch",
  "Music Concert",
  "Other",
];

const eventImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&auto=format&fit=crop",
    title: "Gala Night",
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&auto=format&fit=crop",
    title: "Wedding Celebration",
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=800&auto=format&fit=crop",
    title: "Corporate Summit",
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&auto=format&fit=crop",
    title: "Music Festival",
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&auto=format&fit=crop",
    title: "Fashion Show",
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&auto=format&fit=crop",
    title: "Art Exhibition",
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&auto=format&fit=crop",
    title: "Outdoor Concert",
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=800&auto=format&fit=crop",
    title: "Wedding Reception",
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1557426272-fc759fdf7a8d?w=800&auto=format&fit=crop",
    title: "Corporate Dinner",
  },
  {
    id: 10,
    url: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=800&auto=format&fit=crop",
    title: "Team Building",
  },
  {
    id: 11,
    url: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=800&auto=format&fit=crop",
    title: "Concert Crowd",
  },
  {
    id: 12,
    url: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=800&auto=format&fit=crop",
    title: "New Year Party",
  },
  {
    id: 13,
    url: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&auto=format&fit=crop",
    title: "Fundraising Gala",
  },
  {
    id: 14,
    url: "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=800&auto=format&fit=crop",
    title: "Photography Workshop",
  },
  {
    id: 15,
    url: image_0901,
    title: "Birthday Party",
  },
  {
    id: 16,
    url: "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=800&auto=format&fit=crop",
    title: "Wedding Decor",
  },
  {
    id: 17,
    url: "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=800&auto=format&fit=crop",
    title: "Festival",
  },
  {
    id: 18,
    url: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800&auto=format&fit=crop",
    title: "Business Conference",
  },
  {
    id: 19,
    url: "https://images.unsplash.com/photo-1531058020387-3be344556be6?w=800&auto=format&fit=crop",
    title: "Award Ceremony",
  },
  {
    id: 20,
    url: "https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&auto=format&fit=crop",
    title: "After Party",
  },
  {
    id: 21,
    url: "https://t3.ftcdn.net/jpg/15/92/32/00/360_F_1592320068_XJAxKjDje8i0Kf5turIbJGihN38t34Q7.jpg",
    title: "Wedding Party",
  },
  {
    id: 22,
    url: "https://img.weddingbazaar.com/photos/pictures/006/971/755/original/mini_magick20230606-12042-shrmyj.jpg?1686059924",
    title: "Wedding Party",
  },
  {
    id: 23,
    url: "https://img.freepik.com/premium-photo/bed-with-red-roses-it-yellow-curtain-with-words-enter-top_865967-1299847.jpg?semt=ais_hybrid&w=740&q=80",
    title: "Wedding Party",
  },
  {
    id: 24,
    url: "https://img.freepik.com/premium-photo/table-with-chandelier-flowers-it_855183-635.jpg?semt=ais_incoming&w=740&q=80",
    title: "Wedding Party",
  },
  {
    id: 25,
    url: "https://i.pinimg.com/236x/f4/ac/37/f4ac3724b906d504f4d661059f3976ed.jpg",
    title: "Wedding Party",
  },
  {
    id: 26,
    url: "https://swastikeventsco.com/wp-content/uploads/2021/10/DSC_5540-min.jpg",
    title: "Wedding Party",
  },
  {
    id: 27,
    url: "https://www.nerolac.com/sites/default/files/styles/1920x548/public/2025-01/Wedding%20Decoration%20Ideas%20and%20Trends_Desktop%201920%20x%20548.jpg.webp?itok=q1NHn5i2",
    title: "Wedding Party",
  }
];

// ----- Styled Components for Auto-Flying Cards -----
const CardsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(5),
  position: "relative",
  flexWrap: "nowrap",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(3),
  },
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(2),
  },
}));

const StyledCard = styled(Paper)(({ theme }) => ({
  flex: "1 1 0",
  minWidth: 0,
  maxWidth: 600,
  width: "100%",
  height: 500,
  borderRadius: theme.shape.borderRadius * 2,
  overflow: "hidden",
  boxShadow: theme.shadows[12],
  position: "relative",
  zIndex: 1,
  transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: theme.shadows[20],
  },
  [theme.breakpoints.down("md")]: {
    height: 380,
    maxWidth: 450,
  },
  [theme.breakpoints.down("sm")]: {
    height: 280,
    maxWidth: "45vw",
  },
}));

const CardImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
});

const Placeholder = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.grey[200],
  color: theme.palette.text.secondary,
  fontSize: "1.5rem",
  fontWeight: 500,
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const FlyingImage = styled("img")(
  ({ theme, $isFlying, $startPos, $endPos }) => ({
    position: "fixed",
    width: $startPos?.width || "auto",
    height: $startPos?.height || "auto",
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: theme.shadows[16],
    objectFit: "cover",
    zIndex: 9999,
    pointerEvents: "none",
    animation: $isFlying ? "fly 0.8s ease-in-out forwards" : "none",
    left: $startPos?.left || 0,
    top: $startPos?.top || 0,

    "@keyframes fly": {
      "0%": {
        left: $startPos?.left,
        top: $startPos?.top,
        transform: "scale(1) rotate(0deg)",
        opacity: 1,
      },
      "50%": {
        transform: "scale(1.08) rotate(3deg)",
        opacity: 0.9,
      },
      "100%": {
        left: $endPos?.left,
        top: $endPos?.top,
        transform: "scale(0.95) rotate(0deg)",
        opacity: 0.8,
      },
    },
  }),
);

// Auto-Flying Cards Component
const TwoCardAutoFly = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [leftImage, setLeftImage] = useState(eventImages[0]);
  const [rightImage, setRightImage] = useState(null);
  const [nextImageIndex, setNextImageIndex] = useState(1);
  const [isFlying, setIsFlying] = useState(false);
  const [startPos, setStartPos] = useState(null);
  const [endPos, setEndPos] = useState(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  const sourceCardId = leftImage ? "card-left" : "card-right";
  const destCardId = leftImage ? "card-right" : "card-left";

  const flyToOtherCard = () => {
    const fromCard = document.getElementById(sourceCardId);
    const toCard = document.getElementById(destCardId);

    if (!fromCard || !toCard) return;

    const fromRect = fromCard.getBoundingClientRect();
    const toRect = toCard.getBoundingClientRect();

    setStartPos({
      left: fromRect.left + "px",
      top: fromRect.top + "px",
      width: fromRect.width + "px",
      height: fromRect.height + "px",
    });

    setEndPos({
      left: toRect.left + "px",
      top: toRect.top + "px",
    });

    setIsFlying(true);

    timeoutRef.current = setTimeout(() => {
      setIsFlying(false);

      if (leftImage) {
        setRightImage(eventImages[nextImageIndex]);
        setLeftImage(null);
      } else {
        setLeftImage(eventImages[nextImageIndex]);
        setRightImage(null);
      }

      setNextImageIndex((prev) => (prev + 1) % eventImages.length);
      setStartPos(null);
      setEndPos(null);
    }, 800);
  };

  useEffect(() => {
    if (!isPlaying) return;

    const initialTimeout = setTimeout(flyToOtherCard, 500);
    intervalRef.current = setInterval(flyToOtherCard, 2000);

    return () => {
      clearTimeout(initialTimeout);
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [leftImage, rightImage, nextImageIndex, sourceCardId, destCardId, isPlaying]);

  const togglePlay = () => setIsPlaying(!isPlaying);

  const reset = () => {
    setIsPlaying(false);
    setIsFlying(false);
    setLeftImage(eventImages[0]);
    setRightImage(null);
    setNextImageIndex(1);
    setStartPos(null);
    setEndPos(null);
    setTimeout(() => setIsPlaying(true), 100);
  };

  return (
    <Box sx={{ py: 10, backgroundColor: "#f0fbf9" }}>
      <Container maxWidth="xl">
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 700,
            fontFamily: "'Allura', cursive !important",
            color: DARK,
            mb: 2,
          }}
        >
          🕊️ Our Organised Events
        </Typography>
        <div style={{ width: 54, height: 3.5, background: TEAL_GRAD, borderRadius: 2, margin: "0 auto 48px" }} />

        <CardsContainer>
          {/* LEFT CARD */}
          <StyledCard id="card-left">
            {leftImage ? (
              <CardImage src={leftImage.url} alt={leftImage.title} />
            ) : (
              <Placeholder>
                <span style={{ fontSize: "3rem" }}>✨</span>
                Waiting for next image
              </Placeholder>
            )}
            {leftImage && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                  color: "white",
                  p: 3,
                }}
              >
                <Typography variant="h5">{leftImage?.title}</Typography>
              </Box>
            )}
          </StyledCard>

          {/* RIGHT CARD */}
          <StyledCard id="card-right">
            {rightImage ? (
              <CardImage src={rightImage.url} alt={rightImage.title} />
            ) : (
              <Placeholder>
                <span style={{ fontSize: "3rem" }}>✨</span>
                Waiting for next image
              </Placeholder>
            )}
            {rightImage && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                  color: "white",
                  p: 3,
                }}
              >
                <Typography variant="h5">{rightImage?.title}</Typography>
              </Box>
            )}
          </StyledCard>
        </CardsContainer>

        {/* FLYING IMAGE */}
        {isFlying && startPos && endPos && (
          <FlyingImage
            src={eventImages[nextImageIndex].url}
            $isFlying={isFlying}
            $startPos={startPos}
            $endPos={endPos}
            alt="flying event"
          />
        )}

        {/* CONTROLS */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 6 }}>
          <IconButton
            onClick={togglePlay}
            sx={{
              bgcolor: T1,
              color: "white",
              "&:hover": { bgcolor: T2 },
              width: 60,
              height: 60,
            }}
          >
            {isPlaying ? <Pause /> : <PlayArrow />}
          </IconButton>
          <IconButton
            onClick={reset}
            sx={{
              bgcolor: T3,
              color: "white",
              "&:hover": { bgcolor: NAVY },
              width: 60,
              height: 60,
            }}
          >
            <RestartAlt />
          </IconButton>
        </Box>

        {/* STATUS */}
        <Typography
          variant="body1"
          align="center"
          sx={{ mt: 4, color: "#666" }}
        >
          {isPlaying ? "🔵 Auto‑flying" : "⏸️ Paused"} –{" "}
          {leftImage ? "Image on LEFT" : "Image on RIGHT"} • Next:{" "}
          {eventImages[nextImageIndex].title}
        </Typography>
      </Container>
    </Box>
  );
};

const MomentsiaLogo = ({ light = false }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
    <img src={Momentsia_logo} alt="Momentsia" style={{ height: 48, width: "auto", objectFit: "contain" }} />
  </div>
);

// ---------- CONSULT DIALOG WITH EMAILJS ----------
const ConsultDialog = ({ open, onClose }) => {
  const [dialogFormData, setDialogFormData] = useState({ 
    name: "", 
    phone: "", 
    email: "", 
    eventType: "",
    date: "",
    guests: "",
    message: "" 
  });
  const [dialogErrors, setDialogErrors] = useState({});
  const [dialogStatus, setDialogStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateDialogForm = () => {
    const newErrors = {};
    if (!dialogFormData.name?.trim()) newErrors.name = "Name is required";
    if (!dialogFormData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(dialogFormData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!dialogFormData.phone?.trim()) newErrors.phone = "Phone number is required";
    if (!dialogFormData.eventType) newErrors.eventType = "Event type is required";
    if (!dialogFormData.date) newErrors.date = "Date is required";
    setDialogErrors(newErrors);
    return newErrors;
  };

  const handleDialogChange = (e) => {
    const { name, value } = e.target;
    setDialogFormData({ ...dialogFormData, [name]: value });
    if (dialogErrors[name]) {
      setDialogErrors({ ...dialogErrors, [name]: "" });
    }
  };

  const handleDialogSubmit = async (e) => {
    e.preventDefault();
    
    const validationErrors = validateDialogForm();
    if (Object.keys(validationErrors).length > 0) return;
    
    setIsSubmitting(true);
    setDialogStatus("Sending...");

    const templateParams = {
      from_name: dialogFormData.name.trim(),
      from_email: dialogFormData.email.trim(),
      from_phone: dialogFormData.phone?.trim() || "Not provided",
      event_type: dialogFormData.eventType,
      event_date: dialogFormData.date,
      guests: dialogFormData.guests?.toString().trim() || "Not specified",
      message: dialogFormData.message?.trim() || "No additional message provided",
      submitted_at: new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    try {
      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );
      
      console.log("Dialog - Email sent successfully!", response);
      setDialogStatus("✓ Request sent successfully! We'll contact you within 24 hours.");
      setDialogFormData({ name: "", phone: "", email: "", eventType: "", date: "", guests: "", message: "" });
      setDialogErrors({});
      
      setTimeout(() => {
        setDialogStatus("");
        onClose();
      }, 2000);
    } catch (error) {
      console.error("Dialog - Failed to send email:", error);
      setDialogStatus("❌ Failed to send. Please try again or call us directly.");
      setTimeout(() => setDialogStatus(""), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!open) return null;
  
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={onClose} style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.6)" }} />
      <div style={{ position: "relative", background: "#fff", borderRadius: 14, padding: "40px 36px", maxWidth: 520, width: "90%", boxShadow: "0 24px 64px rgba(0,0,0,0.25)", maxHeight: "90vh", overflowY: "auto" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 14, right: 18, background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#aaa" }}>✕</button>
        <div style={{ height: 4, background: TEAL_GRAD, borderRadius: 4, marginBottom: 24 }} />
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
          <img src={Momentsia_logo} alt="Momentsia" style={{ height: 32, width: "auto" }} />
          <h3 style={{ margin: 0, color: DARK, fontWeight: 800, fontSize: 20 }}>Plan Your Perfect Event</h3>
        </div>
        <p style={{ color: "#888", fontSize: 13, margin: "0 0 22px" }}>Share your event details – we'll create a customized proposal within 24 hours.</p>
        
        <form onSubmit={handleDialogSubmit}>
          <input 
            type="text" 
            name="name" 
            placeholder="Full Name *" 
            value={dialogFormData.name}
            onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.name ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14, boxSizing: "border-box" }} 
          />
          {dialogErrors.name && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.name}</p>}
          
          <input 
            type="tel" 
            name="phone" 
            placeholder="Phone Number *" 
            value={dialogFormData.phone}
            onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.phone ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14, boxSizing: "border-box" }} 
          />
          {dialogErrors.phone && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.phone}</p>}
          
          <input 
            type="email" 
            name="email" 
            placeholder="Email Address *" 
            value={dialogFormData.email}
            onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.email ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14, boxSizing: "border-box" }} 
          />
          {dialogErrors.email && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.email}</p>}
          
          <select 
            name="eventType" 
            value={dialogFormData.eventType}
            onChange={handleDialogChange}
            required
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.eventType ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14, background: "#fff" }}
          >
            <option value="">Select Event Type *</option>
            {eventTypes.map(type => <option key={type} value={type}>{type}</option>)}
          </select>
          {dialogErrors.eventType && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.eventType}</p>}
          
          <input 
            type="date" 
            name="date" 
            value={dialogFormData.date}
            onChange={handleDialogChange}
            required
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.date ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14 }} 
          />
          {dialogErrors.date && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.date}</p>}
          
          <input 
            type="number" 
            name="guests" 
            placeholder="Approximate Guests" 
            value={dialogFormData.guests}
            onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: "1.5px solid #e0e0e0", borderRadius: 7, fontSize: 14 }} 
          />
          
          <textarea 
            name="message" 
            placeholder="Tell us about your event (themes, requirements, ideas)..." 
            rows={3} 
            value={dialogFormData.message}
            onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 18, padding: "11px 14px", border: "1.5px solid #e0e0e0", borderRadius: 7, fontSize: 14, resize: "vertical" }} 
          />
          
          <button 
            type="submit" 
            disabled={isSubmitting}
            style={{ width: "100%", padding: "13px 0", background: TEAL_GRAD, color: "#fff", border: "none", borderRadius: 7, fontWeight: 700, fontSize: 15, cursor: isSubmitting ? "not-allowed" : "pointer", opacity: isSubmitting ? 0.7 : 1 }}
          >
            {isSubmitting ? "Submitting..." : "Submit Inquiry"}
          </button>
          {dialogStatus && <p style={{ marginTop: 16, fontSize: 12, textAlign: "center", color: dialogStatus.includes("✓") ? T2 : T1 }}>{dialogStatus}</p>}
        </form>
      </div>
    </div>
  );
};

// ---------- TEAM MEMBERS ----------
const teamMembers = [
  {
    name: "Suman Kumar Das",
    role: "Founder & CEO",
    bio: "“18+ years in event production & education industry, visionary behind Edvisor's success.The Co-Founder is an experienced Admission Consultant with 18 years of expertise in college admissions and student counseling. Alongside this, they possess strong experience in technical services, real estate consulting, and creative decoration solutions. This multi-industry exposure enables well-rounded guidance, efficient execution, and reliable outcomes.”",
    img: director1,
  },
  {
    name: "Arpita Bisai",
    role: "Creative Director",
    bio: "“A creative visionary with expertise in digital design and interior aesthetics, Arpita Bisai leads with a refined balance of creativity and functionality. Her fine arts foundation and design sensibility shape elegant spaces and impactful visual identities that elevate both brands and environments.”",
    img: director2,
  }
];

// ---------- CORE VALUES ----------
const coreValues = [
  { icon: <StarIcon sx={{ fontSize: 40 }} />, title: "Excellence", desc: "We chase perfection in every detail, from concept to curtain call." },
  { icon: <GroupsIcon sx={{ fontSize: 40 }} />, title: "Collaboration", desc: "Your vision + our expertise = unforgettable magic." },
  { icon: <EmojiEventsIcon sx={{ fontSize: 40 }} />, title: "Integrity", desc: "Transparent pricing, honest timelines, and zero hidden surprises." },
  { icon: <CelebrationIcon sx={{ fontSize: 40 }} />, title: "Innovation", desc: "We blend tradition with cutting-edge tech to wow modern audiences." },
];

// ---------- WORK PROCESS ----------
const workSteps = [
  { icon: <LightbulbIcon sx={{ fontSize: 36 }} />, title: "1. Discovery", desc: "We listen to your vision, goals, and budget – no assumptions." },
  { icon: <DesignServicesIcon sx={{ fontSize: 36 }} />, title: "2. Design", desc: "Our creative team crafts a unique concept with mood boards and layouts." },
  { icon: <BuildIcon sx={{ fontSize: 36 }} />, title: "3. Execution", desc: "Vendor coordination, on‑site management, and real‑time problem solving." },
  { icon: <CelebrationIcon sx={{ fontSize: 36 }} />, title: "4. Delivery", desc: "You enjoy the moment; we handle everything – then follow up for perfection." },
];

// ════════════════════ ABOUT US COMPONENT ════════════════════
export default function AboutUs() {
  const [openForm, setOpenForm] = useState(false);

  return (
    <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif", margin: 0, padding: 0, color: DARK }}>
      <link href="https://fonts.googleapis.com/css2?family=Allura&display=swap" rel="stylesheet" />
      <style>{`
        *{box-sizing:border-box;}body{margin:0;}
        h1, h2 {
          font-family: 'Allura', cursive !important;
          letter-spacing: 1px;
        }
        h3, h4, h5, h6, p, a, li, button, input, textarea {
          font-family: 'Segoe UI', Arial, sans-serif;
        }
        .value-card, .step-card, .team-card {
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .value-card:hover, .step-card:hover, .team-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 30px rgba(14,207,176,0.2) !important;
        }
        .cb:hover{opacity:0.88;transform:translateY(-1px);}
      `}</style>

      {/* Navigation Component */}
      <Navigation onPlanEventClick={() => setOpenForm(true)} />

      {/* ABOUT HERO */}
      <div style={{ position: "relative", width: "100%", background: "#000" }}>
        <div style={{ position: "relative", width: "100%", height: "calc(100vh - 80px)", minHeight: 480, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <img src="https://images.unsplash.com/photo-1531058020387-3be344556be6?w=1920&h=1080&fit=crop" alt="About Momentsia"
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 1 }} />
          <div style={{ position: "absolute", inset: 0, background: `linear-gradient(135deg,rgba(7,122,110,0.75) 0%,rgba(0,0,0,0.55) 100%)`, zIndex: 2 }} />
          <div style={{ position: "relative", zIndex: 3, textAlign: "center", width: "90%", maxWidth: 880, margin: "0 auto" }}>
            <div style={{ width: 60, height: 3.5, background: TEAL_GRAD, borderRadius: 2, margin: "0 auto 18px" }} />
            <h1 style={{ color: "#fff", fontSize: "clamp(2rem,5vw,4rem)", fontWeight: 800, lineHeight: 1.22, textShadow: "0 2px 20px rgba(0,0,0,0.5)", margin: "0 0 14px" }}>
              Crafting Moments That Last Forever
            </h1>
            <p style={{ color: "rgba(255,255,255,0.92)", fontSize: "clamp(1rem,2vw,1.2rem)", margin: "0 0 28px" }}>
              We don't just manage events — we architect emotions, memories, and legacy.
            </p>
            <button className="cb" onClick={() => setOpenForm(true)} style={{ background: TEAL_GRAD, color: "#fff", border: "none", borderRadius: 8, padding: "14px 40px", fontWeight: 700, fontSize: 15, cursor: "pointer", boxShadow: `0 8px 26px rgba(14,207,176,0.45)` }}>
              Start Your Journey
            </button>
          </div>
        </div>
      </div>

      {/* OUR STORY SECTION */}
      <section style={{ background: "#fff", padding: "80px 24px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 48, alignItems: "center" }}>
          <div>
            <p style={{ color: T2, fontWeight: 700, fontSize: 12, textTransform: "uppercase", letterSpacing: 2.5, marginBottom: 12 }}>Our Story</p>
            <h2 style={{ fontSize: "clamp(1.4rem,3vw,2.5rem)", fontWeight: 800, color: DARK, marginBottom: 20 }}>From a dream to India's most trusted event & talent agency</h2>
            <div style={{ width: 54, height: 3.5, background: TEAL_GRAD, borderRadius: 2, marginBottom: 28 }} />
            <p style={{ color: "#555", lineHeight: 1.8, marginBottom: 18, fontSize: 15 }}>
              Founded in Kolkata in 2018, Momentsia began with a simple belief: every celebration deserves to be felt, not just organized. 
              We saw a gap between event companies that focused on logistics versus those that prioritized human emotion.
            </p>
            <p style={{ color: "#555", lineHeight: 1.8, marginBottom: 18, fontSize: 15 }}>
              Today, we've grown into a full-service event management and talent agency, orchestrating 500+ successful events — from intimate weddings to large-scale corporate galas and music festivals. 
              Our talent division now represents 100+ artists across India, helping them build iconic careers.
            </p>
            <p style={{ color: "#555", lineHeight: 1.8, fontSize: 15 }}>
              We remain committed to our original mission: <strong style={{ color: T2 }}>designing experiences that people carry in their hearts long after the lights go out.</strong>
            </p>
          </div>
          <div style={{ borderRadius: 24, overflow: "hidden", boxShadow: "0 20px 40px rgba(14,207,176,0.2)" }}>
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop" alt="Team working" style={{ width: "100%", height: "auto", display: "block" }} />
          </div>
        </div>
      </section>

      {/* AUTO-FLYING CARDS SECTION */}
      <TwoCardAutoFly />

      {/* CORE VALUES */}
      <section style={{ background: "#f0fbf9", padding: "80px 24px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", textAlign: "center" }}>
          <p style={{ color: T2, fontWeight: 700, fontSize: 12, textTransform: "uppercase", letterSpacing: 2.5 }}>What Drives Us</p>
          <h2 style={{ fontSize: "clamp(1.4rem,3vw,2.1rem)", fontWeight: 800, color: DARK }}>Our Core Values</h2>
          <div style={{ width: 54, height: 3.5, background: TEAL_GRAD, borderRadius: 2, margin: "16px auto 48px" }} />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 30 }}>
            {coreValues.map(val => (
              <div key={val.title} className="value-card" style={{ background: "#fff", borderRadius: 20, padding: "32px 20px", textAlign: "center", boxShadow: "0 8px 20px rgba(0,0,0,0.05)", transition: "all 0.3s" }}>
                <div style={{ color: T1, marginBottom: 20 }}>{val.icon}</div>
                <h3 style={{ fontSize: 20, fontWeight: 800, color: DARK, marginBottom: 12 }}>{val.title}</h3>
                <p style={{ color: "#666", fontSize: 14, lineHeight: 1.6 }}>{val.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW WE WORK */}
      <section style={{ background: "#fff", padding: "80px 24px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", textAlign: "center" }}>
          <p style={{ color: T2, fontWeight: 700, fontSize: 12, textTransform: "uppercase", letterSpacing: 2.5 }}>Our Process</p>
          <h2 style={{ fontSize: "clamp(1.4rem,3vw,2.1rem)", fontWeight: 800, color: DARK }}>How We Bring Your Vision to Life</h2>
          <div style={{ width: 54, height: 3.5, background: TEAL_GRAD, borderRadius: 2, margin: "16px auto 48px" }} />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 30 }}>
            {workSteps.map(step => (
              <div key={step.title} className="step-card" style={{ background: "#f0fbf9", borderRadius: 24, padding: "32px 20px", textAlign: "center", transition: "all 0.3s" }}>
                <div style={{ color: T1, marginBottom: 20 }}>{step.icon}</div>
                <h3 style={{ fontSize: 18, fontWeight: 800, color: DARK, marginBottom: 12 }}>{step.title}</h3>
                <p style={{ color: "#666", fontSize: 13.5, lineHeight: 1.6 }}>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ background: `linear-gradient(115deg, ${NAVY} 0%, ${NAVY2} 100%)`, padding: "80px 24px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", textAlign: "center" }}>
          <p style={{ color: T1, fontWeight: 700, fontSize: 12, textTransform: "uppercase", letterSpacing: 2.5 }}>Why Momentsia?</p>
          <h2 style={{ color: "#fff", fontSize: "clamp(1.4rem,3vw,2.1rem)", fontWeight: 800 }}>What Makes Us Different</h2>
          <div style={{ width: 54, height: 3.5, background: TEAL_GRAD, borderRadius: 2, margin: "16px auto 48px" }} />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 30, textAlign: "left" }}>
            {[
              { icon: <CheckCircleIcon />, title: "End-to-End Execution", desc: "From concept to cleanup, we handle every single detail — no stress, no gaps." },
              { icon: <PeopleAltIcon />, title: "Pan-India Talent Network", desc: "Access 100+ curated artists, performers, and influencers across genres." },
              { icon: <TimelineIcon />, title: "Data-Driven Creativity", desc: "We blend analytics with artistry for events that truly resonate." },
              { icon: <EmojiEventsIcon />, title: "Award-Winning Team", desc: "Recognized as 'Best Event Agency' by industry bodies 3 years running." },
            ].map(item => (
              <div key={item.title} style={{ display: "flex", gap: 16, background: "rgba(255,255,255,0.05)", padding: "24px", borderRadius: 16, backdropFilter: "blur(4px)" }}>
                <div style={{ color: T1, minWidth: 44 }}>{item.icon}</div>
                <div>
                  <h3 style={{ color: "#fff", fontSize: 17, marginBottom: 8 }}>{item.title}</h3>
                  <p style={{ color: "rgba(255,255,255,0.7)", fontSize: 13.5, lineHeight: 1.6 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ background: TEAL_GRAD, padding: "70px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <h2 style={{ color: "#fff", fontSize: "clamp(1.6rem,4vw,2.2rem)", fontWeight: 800, marginBottom: 16 }}>Ready to Create Your Masterpiece?</h2>
          <p style={{ color: "rgba(255,255,255,0.9)", fontSize: 16, marginBottom: 32, lineHeight: 1.6 }}>
            Whether it's a wedding, corporate gala, or artist career — we're just a message away.
          </p>
          <button onClick={() => setOpenForm(true)} style={{ background: "#fff", color: T2, border: "none", padding: "14px 42px", borderRadius: 40, fontWeight: 800, fontSize: 16, cursor: "pointer", boxShadow: "0 8px 20px rgba(0,0,0,0.2)", transition: "transform 0.2s" }}
            onMouseEnter={e => e.target.style.transform = "scale(1.02)"} onMouseLeave={e => e.target.style.transform = "scale(1)"}>
            Let's Talk
          </button>
        </div>
      </section>

      <Footer />

      <a href="https://wa.me/918100364941" target="_blank" rel="noreferrer" style={{ position: "fixed", bottom: 24, right: 24, width: 58, height: 58, borderRadius: "50%", background: "#25d366", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 6px 20px rgba(37,211,102,0.4)", zIndex: 9998, textDecoration: "none", fontSize: 28 }}>💬</a>

      <ConsultDialog open={openForm} onClose={() => setOpenForm(false)} />
    </div>
  );
}